module.exports = "/assets/27ec60caf912cac3b31d3a1290ddcc75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon/overtaken.svg
// module id = 184
// module chunks = 0